import { MakeCall } from './createMakeCall';

const addPayoutMethod =
  (makeCall: MakeCall) =>
  (data: {
    accountNumber: string;
    beneficiaryName: string;
    code: string;
    country: string;
    currency: string;
    homeAddress: string;
    iban: string;
    ownerName: string;
    customerUUID: string;
    type: 'iban';
  }) =>
    makeCall<undefined>('POST', `/api/v2/user/me/payout-method`, {
      data,
    });
export { addPayoutMethod };
